import { useMemo, useRef } from "react";
import { RaceInfoMyBets } from "@tvg/ts-types/Race";

type Props = {
  races: RaceInfoMyBets[];
  trackCode: string;
};

function useAllRacesFromTrack(props: Props) {
  const { races, trackCode } = props;
  // Keep the previous filtered result so we can return a stable reference when
  // nothing relevant changed. The upstream `races` array gets a new reference on
  // every subscription tick, but the individual race entities keep their
  // reference when unchanged (Apollo cache), so a shallow element comparison is
  // enough to avoid propagating a new array reference downstream on every tick.
  const previousRef = useRef<RaceInfoMyBets[]>([]);

  return useMemo(() => {
    const filtered = races
      ? races.filter((race) => race.id.includes(trackCode))
      : [];

    const previous = previousRef.current;
    const isUnchanged =
      previous.length === filtered.length &&
      filtered.every((race, index) => race === previous[index as number]);

    if (isUnchanged) {
      return previous;
    }

    previousRef.current = filtered;
    return filtered;
  }, [races, trackCode]);
}

export default useAllRacesFromTrack;
